import DynamicFormUploadDocumentRequestModelBase from '../_generated/modelBases/dynamic-form-upload-document-request-model-base';

export default class DynamicFormUploadDocumentRequestModel extends DynamicFormUploadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
